module.exports = __webpack_public_path__ + "img/icon3.56d870cd.png";